export const PostHogEvents = {
  createReport(template: string) {
    return ["Create report", { template }] as const;
  },
  failedToLogin(type: string) {
    return ["Failed to login", { type }] as const;
  },
};
